
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Select, notification, Spin } from "antd";
import { SubGroupGrid } from "../../../../../Common/UIConstants";


import { useNavigate, useLocation } from "react-router-dom";
import SubGroupPopup from "../../../../CommonScreens/CreateSubGroup";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { CONFIGURATION_SUB_GROUP, CONFIGURATION_SUBGROUPS } from "../../../../../Common/Constants";

const SubGroup = () => {
  const navigate = useNavigate();
  const [isAdd, setIsAdd] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const { makeRequest, loading, isSaving } = useStoreUpdaterWithAPI();
  const [selectedGroupNameID, setSelectedGroupNameID] = useState(7);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [flowSubGroupList, setFlowSubGroupList] = useState([]);
  const [flowGroupList, setFlowGroupList] = useState([]);

  const [calculationTypeList, setCalculationTypeList] = useState([]);

  const [reportStatusList, setReportStatusList] = useState([]);
  const [ updateRecordSub, setUpdateRecord] = useState([])
  const [form] = Form.useForm();

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
useEffect(() => {
  fetchFlowGroupList();
  fetchCalculationTypeMaster();
  fetchReportStatus();
}, []);  



const fetchFlowGroupList = () => {
  makeRequest({
    type: APIConstants.GET,
    url: APIConstants.GET_FLOW_GROUP_DETAILS,
  })
    .then((res) => {
      setFlowGroupList(res); 
      // console.log(flowGroupList)     
    })
    .catch((err) => {
      console.error("Error fetching flow group list:", err);
    });
};

const fetchCalculationTypeMaster = () => {
  makeRequest({
    type: APIConstants.GET,
    url: APIConstants.GET_CALCULATION_TYPE_MASTER_DETAILS,
  })
    .then((res) => {
      setCalculationTypeList(res); 
      // console.log(flowGroupList)     
    })
    .catch((err) => {
      console.error("Error fetching flow group list:", err);
    });
};

const fetchReportStatus = () => {
  makeRequest({
    type: APIConstants.GET,
    url: APIConstants.GET_REPORT_STATUS_MASTER_DETAILS,
  })
    .then((res) => {
      setReportStatusList(res); 
      // console.log(flowGroupList)     
    })
    .catch((err) => {
      console.error("Error fetching flow group list:", err);
    });
};



  useEffect(() => {
    if (location.pathname.includes(`${CONFIGURATION_SUB_GROUP}/sub-group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
    } else if (location.pathname.includes(`${CONFIGURATION_SUB_GROUP}/sub-group-update-popup`)) {
      setIsUpdate(true);
      setIsAdd(false);
    } else {
      setIsAdd(false);
      setIsUpdate(false);
    }
  }, [location.pathname]);






  //for grid
  const handleGroupNameChange = (changedValue) => {
    setSelectedGroupNameID(Number(changedValue));
    setIsSearchClicked(false);
    console.log(selectedGroupNameID)
  };


  //for frid(used for grid and update form)
  const handleSearchClick = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${selectedGroupNameID}`,
    }).then((res) => {
      setFlowSubGroupList(res);
      setIsSearchClicked(true);
      // console.log(res)
    });
   
  };   

  const updateFilteredData = (data) => {
    const filtered = data.filter((item) => Number(item.groupID) === selectedGroupNameID);
    setFilteredData(filtered);
  };

  useEffect(() => {
    if (isSearchClicked) {
      const filteredData = flowSubGroupList.filter(
        (item) => Number(item.groupID) === selectedGroupNameID
      );
      setFilteredData(filteredData);
    }

    // console.log(filteredData)
  }, [selectedGroupNameID, isSearchClicked, flowSubGroupList]);

  const handleClear = () => {
    form.resetFields();
  };

  const handleAddPopup = () => {
    setIsAdd(true);
    handleClear();
    navigate(`${CONFIGURATION_SUB_GROUP}/sub-group-add-popup`);
    // Resetting the form and navigating to the add popup screen
  
    
  };
  

  const handleUpdatePopup = (record) => {
    
    navigate(`${CONFIGURATION_SUB_GROUP}/sub-group-update-popup`);
    setUpdateRecord(record)
    // console.log(record)

    
  };

  const handleDeleteSubmit = (subGroupID) => {
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_FLOW_SUB_GROUP_METER_DETAILS}?SubGroupID=${subGroupID}`,
    }).then(() => {
      const updatedFlowGroupList = filteredData.filter(
        (item) => item.subGroupID !== subGroupID
      );
      setFlowSubGroupList(updatedFlowGroupList);
      notification.success({ message: "Successfully Deleted" });
      handleClear();
    });
  };

  const fetchUpdatedFlowSubGroupList = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${selectedGroupNameID}`,
    }).then((res) => {
      setFlowSubGroupList(res);
      // console.log(res)
      updateFilteredData(res);
      // setIsSearchClicked(true);
      // console.log("Updated flowSubGroupList:", res);
    }).catch((err) => {
      console.error("Error fetching updated flow subgroup list:", err);
    });
  };

  return (
    <div>
      <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
        <div className="flex justify-between">
          <div className="flex space-x-2">
          <p className={`ml-2 mt-1 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>Select Module:</p>
            <Select dropdownClassName={isdarkMode ? 'select-dropdown-background ' : 'light-mode-dropdown'}
              placeholder="Select Module"
              // className="w-auto"
              className={`w-auto  ${isdarkMode ? 'custom-table-subgroup-dropdown ' : 'whitemode'} `}
              onChange={handleGroupNameChange} //change to group module later
            >
              {flowGroupList.map((item) => (
                <Select.Option key={item.groupID} value={item.groupID}>
                  {item.groupName}
                </Select.Option>
              ))}
            </Select>

          <p className={`ml-2 mt-1 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>Select Group:</p>
            <Select dropdownClassName={isdarkMode ? 'select-dropdown-background ' : 'light-mode-dropdown'}
              placeholder="Select Group"
              // className="w-auto"
              className={`w-auto  ${isdarkMode ? 'custom-table-subgroup-dropdown ' : 'whitemode'} `}
              onChange={handleGroupNameChange}
            >
              {flowGroupList.map((item) => (
                <Select.Option key={item.groupID} value={item.groupID}>
                  {item.groupName}
                </Select.Option>
              ))}
            </Select>
            <Button className="blue-btn" onClick={handleSearchClick}>
              Search
              
            </Button>
          </div>
          <Button onClick={handleAddPopup} className="blue-btn mb-2">
            Add SubGroup
          </Button>
        </div>
        <SubGroupPopup
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          flowGroupList={flowGroupList}
          updateRecordSub={updateRecordSub}
          flowSubGroupList={flowSubGroupList}
          setFlowSubGroupList={setFlowSubGroupList}
          selectedGroupNameID={selectedGroupNameID}
          fetchFlowGroupList={fetchFlowGroupList}
          fetchUpdatedFlowSubGroupList={fetchUpdatedFlowSubGroupList} 
          title={'SubGroup Details'}

          
         
        />
<Spin indicator={<Spin size="large" />} spinning={loading}>
        <SubGroupGrid
          handleUpdatePopup={handleUpdatePopup}
          handleDeleteSubmit={handleDeleteSubmit}
          flowSubGroupList={filteredData}
          calculationTypeList={calculationTypeList}
          reportStatusList={reportStatusList}
        />
        </Spin>
      </Card>
    </div>
  );
};

export default SubGroup;

